import useSWR from "swr";

import { fetcher } from "../config/axiosConfig.ts";
import { BaseUrl, swrOptions } from "../const.ts";
import { IMyTicketsOldUpcoming } from "../model.ts";

export function useMyTickets() {
  const { data } = useSWR<IMyTicketsOldUpcoming>(
    `${BaseUrl}/event-order-ms/ticket/my-orders`,
    fetcher,
    swrOptions
  );
  return { tickets: data?.body };
}
